import styled, { CSSProperties } from "styled-components";

export const Container = styled.div<{ filter?: number }>`
	position: relative;
	font-size: 1rem;
	width: 9.5em;
	height: 6.22em;
	margin-top: 0.4em; //temporary
	display: flex;
	cursor: pointer;
	filter: grayscale(${(props) => props.filter});
	user-select: none;
`;

export const IconImage = styled.img`
	width: 100%;
	position: relative;
	bottom: 0%;
	object-fit: contain;
	z-index: 2;
	transform-origin: bottom center;
`;

export const NotificationIcon = styled.div`
	position: absolute;
	top: 4%;
	right: 4%;
	z-index: 3;
	width: 1.625em;
	height: 1.625em;
	background-color: #66cc32;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #fff;
	text-align: center;
	font-family: Inter;
	font-size: 1em;
	font-style: normal;
	font-weight: 700;
	line-height: 0.9375em;
`;

export const ProgressBarContainer = styled.div`
	position: absolute;
	bottom: 1%;
	left: 1.6em;
	font-size: 0.9em;
	width: 7.2em;
`;

export const RewardContainer = styled.div`
	position: absolute;
	bottom: 11.5%;
	right: 1em;
	z-index: 2;
	justify-content: center;
	align-items: center;
	display: flex;
	height: 4.7em;
	width: 40%;
`;

export const RewardItem = styled.div<{ width?: string }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
`;

export const ItemImage = styled.img`
	object-fit: contain;
	justify-self: center;
	align-self: center;
	width: 100%;
	height: 3.6em;
`;

export const CountdownStyles: CSSProperties = {
	fontSize: "0.8em",
	margin: "0em 0.36em",
	padding: "0.2em 0.5em",
	zIndex: 3,
	whiteSpace: "nowrap",
	top: "10%",
	left: "46%",
	transform: "translate(-50%, -50%)",
	background: "rgba(208, 110, 223, 0.90)"
};

export const CountdownIconStyles: CSSProperties = {
	width: "0em",
	height: "0em"
};

export const CountdownLabelStyles: CSSProperties = {
	marginLeft: "0em"
};
